"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatContentInfoIntoUrl = void 0;
const siteContentRules_1 = require("./siteContentRules");
const formatContentInfoIntoUrl = (content) => {
    const { site, contentType, urlVariant } = content;
    const locator = `${site}.${contentType}.${urlVariant}`;
    if (!siteContentRules_1.siteContentRules[locator]) {
        throw new Error(`Unknown content type: ${locator}`);
    }
    return siteContentRules_1.siteContentRules[locator].formatUrl(content);
};
exports.formatContentInfoIntoUrl = formatContentInfoIntoUrl;
//# sourceMappingURL=formatContentInfoIntoUrl.js.map